import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { errMsg } from "@/lib/errors";
import { Flame } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [ident, setIdent] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(ident, pw);
      toast.success(`Welcome back, ${u.display_name || u.username}`);
      nav(u.role === "admin" ? "/admin" : (u.is_artist ? "/dashboard" : "/browse"));
    } catch (err) {
      toast.error(errMsg(err, "Login failed"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4 py-12">
      <form onSubmit={submit} className="w-full max-w-md border border-[#2A2A2A] bg-[#121212] p-8">
        <div className="flex items-center gap-2 mb-8">
          <div className="h-8 w-8 grid place-items-center bg-[#FF4500] text-black"><Flame className="h-5 w-5" /></div>
          <div className="font-display text-2xl font-bold tracking-tighter">SIGN IN</div>
        </div>
        <div className="space-y-4">
          <div>
            <Label className="font-mono text-xs uppercase tracking-widest text-gray-400">Username or email</Label>
            <Input data-testid="login-identifier" required value={ident} onChange={(e) => setIdent(e.target.value)}
                   className="mt-2 rounded-none bg-black border-[#2A2A2A] font-mono h-11" />
          </div>
          <div>
            <Label className="font-mono text-xs uppercase tracking-widest text-gray-400">Password</Label>
            <Input data-testid="login-password" required type="password" value={pw} onChange={(e) => setPw(e.target.value)}
                   className="mt-2 rounded-none bg-black border-[#2A2A2A] font-mono h-11" />
          </div>
          <Button data-testid="login-submit" disabled={busy} type="submit"
                  className="w-full rounded-none bg-[#FF4500] hover:bg-[#E53E00] text-black font-mono text-xs uppercase tracking-widest h-11">
            {busy ? "Signing in..." : "Enter MeloCraft"}
          </Button>
        </div>
        <div className="mt-6 text-center font-mono text-xs text-gray-500">
          <Link to="/forgot-password" className="text-[#FF4500] hover:brightness-125 block mb-2">Forgot password?</Link>
          No account? <Link to="/register" className="text-[#FF4500] hover:brightness-125">Join MeloCraft</Link>
        </div>
      </form>
    </div>
  );
}
